(function () {
  var storageKey = 'raztechs-theme-mode';
  var root = document.documentElement;

  function getStoredMode() {
    try {
      return window.localStorage.getItem(storageKey);
    } catch (error) {
      return null;
    }
  }

  function storeMode(mode) {
    try {
      window.localStorage.setItem(storageKey, mode);
    } catch (error) {
      return;
    }
  }

  function applyMode(mode) {
    var isDark = mode === 'dark';
    root.setAttribute('data-raztechs-mode', isDark ? 'dark' : 'light');

    document.querySelectorAll('[data-raztechs-theme-toggle]').forEach(function (button) {
      var label = isDark ? 'Switch to light mode' : 'Switch to dark mode';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', isDark ? 'true' : 'false');
      button.classList.toggle('is-dark', isDark);

      var labelNode = button.querySelector('[data-raztechs-theme-toggle-label]');
      if (labelNode) labelNode.textContent = label;
    });
  }

  function init() {
    var storedMode = getStoredMode();
    applyMode(storedMode === 'dark' ? 'dark' : 'light');

    document.querySelectorAll('[data-raztechs-theme-toggle]').forEach(function (button) {
      button.addEventListener('click', function () {
        var nextMode = root.getAttribute('data-raztechs-mode') === 'dark' ? 'light' : 'dark';
        storeMode(nextMode);
        applyMode(nextMode);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
